export const useRoute = () => undefined;